import { CALL_API } from '../../../middleware/api';
import * as ActionTypes from '../betTypes';
import { DELETE_BETSLIP } from '../coupon';
export function fetchBetTypes(data) {
    var _a;
    return _a = {
            type: ActionTypes.REQUEST_BET_TYPES
        },
        _a[CALL_API] = {
            endpoint: '/bet/web/basket/bet-types',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_REQUEST_BET_TYPES,
                ActionTypes.FAILURE_REQUEST_BET_TYPES
            ],
            credentials: true,
            data: data
        },
        _a;
}
export function requestBetTypes() {
    return function (dispatch, getState) {
        var couponBetSlips = getState().coupon.get('betSlips');
        if (couponBetSlips.size === 0) {
            return { type: DELETE_BETSLIP };
        }
        var factors = [];
        couponBetSlips.forEach(function (r) {
            var rate = r.get('rate');
            var match = r.get('match');
            var basket = {
                eventId: rate.get('matchId'),
                eventTimeAndZone: match.get('timeAndZone'),
                outcomeId: rate.get('outcomeId'),
                factorId: rate.get('id')
            };
            factors.push(basket);
        });
        return dispatch(fetchBetTypes(factors));
    };
}



// WEBPACK FOOTER //
// ./src/actions/coupon/creators/betTypes.js